import { getStore } from '@/store'
import context from '@/context'
import { actionCreators } from '@/store/Notifications'
import { actionCreators as backgroundJobs } from '@/store/backgroundJobs'
import { actionCreators as activeTaskActions } from '@/store/myActiveTask'
import { actionCreators as identityActions } from '@/store/Identity'
import debug from 'debug'
import { useSignalR } from '@/hooks/useSignalR'
const log = debug('app:hubs:common')

const isNotificationForThisApp = (userNotification) => {
  if (context.isInternalApp()) { return !userNotification.notification.notificationName.endsWith('_External') }
  if (context.isReportApp()) { return !userNotification.notification.notificationName.endsWith('_Internal') }

  return true
}
const isJobProgressForThisApp = (jobProgress) => {
  if (context.isInternalApp()) { return jobProgress.requestOrigin === 1 || jobProgress.requestOrigin === 0 }
  if (context.isReportApp()) { return jobProgress.requestOrigin === 2 || jobProgress.requestOrigin === 0 }

  return true
}

export function useCommonHub () {
  useSignalR('getNotification', userNotification => {
    if (isNotificationForThisApp(userNotification)) {
      log('Notification received', userNotification)
      // It is necessary to get notification separately due to ABP notification distributer not sending body
      context.api.notificationService.getNotification(userNotification.id)
        .then(fullNotification => {
          getStore().dispatch(actionCreators.newNotification(fullNotification))
        })
        .catch(err => log(err))
    }
  }, [])

  useSignalR('jobProgress', jobProgress => {
    log('Job Progress Changed: %o', jobProgress)
    if (isJobProgressForThisApp(jobProgress)) {
      getStore().dispatch(backgroundJobs.jobProgressChanged(jobProgress))
    }
  }, [])

  useSignalR('taskActivated', task => {
    log('Task Activated: %o', task)
    getStore().dispatch(activeTaskActions.setActiveTask(task))
  }, [])

  useSignalR('userInfoChanged', async () => {
    log('User info changed')
    await getStore().dispatch(identityActions.silentRefresh())
    await getStore().dispatch(identityActions.loadUser())
  }, [])
}



// WEBPACK FOOTER //
// ./src/hooks/useCommonHub.js